export default __webpack_public_path__ + "static/media/cb5bc9d5d9fe10ca5b3ada5064d31db6.jpg";